import { Box, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { bodyWidth } from '../../../../utils/Style';
import { AccountNavbar } from '../../AccountNavbar';
import { UserSummaryCard } from './UserSummaryCard';
import { useAddresses } from '../../../../hooks/useAddresses';
import { AddressCardPlaceholder } from '../../../../components/Address/AddressCardPlaceholder';
import { AddressCard } from '../../../../components/Address/AddressCard';
import { MyOrder } from '../../../../interfaces/Order/MyOrder';
import { getMyOrders } from '../../../../api/Order';
import { OrdersTable } from '../../../../components/Order/OrdersTable';
import { NewAddressCard } from '../../../../components/Address/NewAddressCard';
import { GenericHelmet } from '../../../../components/Helmet/GenericHelmet';

export const AccountPage = () => {
  const { addresses, loading: loadingAddresses } = useAddresses();

  const [orders, setOrders] = useState<MyOrder[]>([]);

  useEffect(() => {
    getMyOrders({ page: 0, pageSize: 5 })
      .then((res) => setOrders(res.data))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Hesabım' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          pb: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <AccountNavbar selectedTab='panel' />

        <Grid container spacing={2} width='100%'>
          <Grid
            size={{
              xs: 12,
              lg: 6,
            }}
          >
            <UserSummaryCard />
          </Grid>

          <Grid
            size={{
              xs: 12,
              lg: 6,
            }}
          >
            {loadingAddresses && <AddressCardPlaceholder />}
            {!loadingAddresses &&
              (addresses.length ? (
                <AddressCard address={addresses[0]} isDefault />
              ) : (
                <NewAddressCard />
              ))}
          </Grid>

          {orders.length > 0 && (
            <Grid size={12}>
              <Paper
                elevation={3}
                sx={{
                  p: 2.5,
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  position: 'relative',
                  justifyContent: 'center',
                  gap: 2.5,
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: '18px' }}>
                  Son Siparişler
                </Typography>

                <OrdersTable
                  orders={orders}
                  totalCount={orders.length}
                  headless
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
};
